export default __webpack_public_path__ + "fonts/left-arrow.svg";